import { render, staticRenderFns } from "./EditRecordModal.vue?vue&type=template&id=434a8ac3&scoped=true"
import script from "./EditRecordModal.vue?vue&type=script&lang=js"
export * from "./EditRecordModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434a8ac3",
  null
  
)

export default component.exports